<template><section><h2>Challenge Descriptions</h2>
<p>在nature上我们有很多论文的配图，这些配图我们很容易通过一些爬虫的技术来获取到。对于nature论文上的配图，我们可以分析他们有哪些特征，以及子类别下有什么共同趋势。例如<a href="https://quickdraw.withgoogle.com/data">Google Creative Lab</a>，提供了人们对物体的手绘。对于同一种物体，不同的人会有不同的绘制喜好。即使是同一个物体，可以按不同笔画数目进行分类，区别也非常明显。甚至于不同的国家的人，对绘制的偏好也有所不同。你是否可以以此为启发，对nature的论文配图做出类似的分析。</p>
<h2>Project Task</h2>
<ul>
<li>Web crawler</li>
<li>Data annotation</li>
<li>Feature Learning</li>
<li>Clustering / Embedding</li>
<li>Statistical analysis</li>
<li>Visualization</li>
</ul>
<h2>Schedule</h2>
<ul>
<li>
<p>Fetch Dataset, analyse tasks, and make a plan to solve it (2-3 week)</p>
</li>
<li>
<p>Process data, implement analysis framework (4-7 week)</p>
</li>
<li>
<p>Mid-term inspection (8 week)</p>
</li>
<li>
<p>Implement analysis system (9-12 week)</p>
</li>
<li>
<p>Inter-team evaluation and modification (13-15 week)</p>
</li>
<li>
<p>Final inspection (16-17 week)</p>
</li>
</ul>
<h2>Resources</h2>
<ul>
<li>https://vast-challenge.github.io/2019/MC2.html</li>
</ul>
</section></template><script>export default {components:{}}</script>